// src/pages/ThankyouPage.js
import React, { useState, useEffect } from "react";
import { IMAGES } from "../assets/image";
import "../pages/ThankyouPage.css";
import { CREDIT_UNION } from "../assets/constants";
import Footer from "../components/common/Footer";
import { Modal, Button } from "react-bootstrap";
import ApplicationService from "../services/ApplicationService";
 
const ThankyouPage = () => {
  const [showModal, setShowModal] = useState(false);
  const [rating, setRating] = useState(0);
  const [hovered, setHovered] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => setShowModal(true), 1000);
    return () => clearTimeout(timer); // Cleanup timer
  }, []);

  const handleSubmitRating = async () => {
    try {
      const guid = localStorage.getItem('current_guid');
  
      if (!guid) {
        console.error('GUID missing. Cannot save review.');
        return;
      }
  
      const response = await ApplicationService.saveAppReview({ guid, rating });
      console.log('Review saved:', response);
      
      localStorage.removeItem('form_data');         
      localStorage.removeItem('current_guid');      
      sessionStorage.clear();                      

      setShowModal(false);
    } catch (error) {
      console.error('Failed to save review:', error.response?.data || error.message);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setRating(0);
    setHovered(0);
  };

  return (
    <>
      <section className={`thankyou-page ${showModal ? 'blurred' : ''}`}>
        <div className="thankyou-background">
          <img 
            src={IMAGES.SlideShowImage} 
            alt="Thankyou Background" 
            className="thankyou-bg-img" 
          />
        </div>

        <div className="thankyou-overlay" />

        <div className="thankyou-content">
          <div className="text-container">
            <div className="thankyou-title">
              <h2>
                <span className="hero-color">Great! </span>
                Thank You For <br/>Submitting  The Application Form
              </h2>
            </div>
            <p className="thankyou-subtitle">
              Your application will be reviewed. If we have any questions,<br/> one of our loan specialists will contact you.  
              For now, feel free <br/> to reach us at{' '}
              <span className="hero-color">{CREDIT_UNION.INFO.PHONE}</span> or{' '}
              <span className="hero-color">{CREDIT_UNION.INFO.EMAIL}</span>
            </p>
          </div>
        </div>
      </section>

      <Modal 
        show={showModal} 
        onHide={handleCloseModal}
        centered
        backdrop="static"
        className="rating-modal"
        size="md"
      >
        <Modal.Body className="text-center py-4 px-4">
          <h4 className="mb-2" style={{ fontWeight: 600 }}>
            How was your experience?
          </h4>
          <p className="text-muted mb-4">
            Please rate us. Your rating helps us improve!
          </p>
          
          <div style={{ 
            fontSize: "2rem", 
            display: "flex", 
            justifyContent: "center", 
            gap: "8px",
            flexWrap: "wrap"
          }}>
            {[
              { level: 1, emoji: '😠', label: 'Very Bad' },
              { level: 2, emoji: '😕', label: 'Bad' },
              { level: 3, emoji: '😐', label: 'Okay' },
              { level: 4, emoji: '🙂', label: 'Good' },
              { level: 5, emoji: '🤩', label: 'Excellent' },
            ].map(({ level, emoji, label }) => (
              <div
                key={level}
                style={{
                  position: 'relative',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  transition: 'transform 0.3s ease',
                  transform: rating === level ? 'scale(1.2)' : 'scale(1)',
                  minWidth: '40px',
                }}
                onMouseEnter={() => setHovered(level)}
                onMouseLeave={() => setHovered(0)}
                onClick={() => setRating(level)}
              >
                {/* Tooltip */}
                <div
                  style={{
                    position: 'absolute',
                    bottom: '3rem',
                    background: 'rgba(0,0,0,0.8)',
                    color: '#fff',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontSize: '0.75rem',
                    opacity: hovered === level ? 1 : 0,
                    transform: hovered === level ? 'translateY(0)' : 'translateY(10px)',
                    transition: 'opacity 0.3s ease, transform 0.3s ease',
                    pointerEvents: 'none',
                    whiteSpace: 'nowrap',
                    zIndex: 10,
                  }}
                >
                  {label}
                </div>

                {/* Emoji */}
                <span
                  style={{
                    cursor: 'pointer',
                    transition: 'transform 0.2s ease',
                    transform: hovered === level ? 'scale(1.3)' : 'scale(1)',
                    opacity: rating === level || hovered === level ? 1 : 0.5,
                  }}
                >
                  {emoji}
                </span>
              </div>
            ))}
          </div>

          <div className="d-flex justify-content-center gap-3 mt-4 flex-wrap">
            <Button variant="outline-secondary" onClick={handleCloseModal}>
              Close
            </Button>
            <Button variant="primary" onClick={handleSubmitRating} disabled={rating === 0}>
              Submit
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <Footer />
    </>
  );
};

export default ThankyouPage;